import componentRegistry from '../registry.js';
import '../../features/cart-assignment/index.js';
import Overlay from '../overlay/index.js';
import rejectNonOkResponse from '../../scripts/api/rejectNonOkResponse.js';

const CSS_PREFIX = 'js-focusPage';
const LIST_FILTER = `${CSS_PREFIX}-listFilter`;
const LIST_CONTAINER = `${CSS_PREFIX}-listContainer`;

/** Editorial page (aka FSI) for both series & participant pages */
export default class FocusPage {
  constructor({ el }) {
    this.el = el;
    this.overlay = new Overlay();

    this.el.addEventListener('click', (e) => {
      // Switch between slider lists
      if (e.target.classList.contains(LIST_FILTER)) {
        e.preventDefault();
        this.#toggleList(e);
      }
    });
  }

  #toggleList(e) {
    const currentFilter = e.target;
    const currentList = document.querySelector(`.${LIST_CONTAINER}[data-listid="${currentFilter.dataset.target}"]`);

    if (currentList) {
      document
        .querySelectorAll(`.${LIST_FILTER}`)
        .forEach((filter) => filter.classList.toggle('selected', filter === currentFilter));
      document
        .querySelectorAll(`.${LIST_CONTAINER}`)
        .forEach((list) => (list.style.display = list === currentList ? 'block' : 'none'));
    }
  }

  // async #loadTab(tab) {
  //   if (tab === this.activeTab) {
  //     return;
  //   }
  //
  //   const url = tab.href;
  //   this.overlay.show();
  //
  //   try {
  //     const data = await getIntervContent(url);
  //     this.#updateFromData(data);
  //     this.#pushState(data, url);
  //   } finally {
  //     this.overlay.hide();
  //   }
  // }

  // #updateFromData({ tabType, html, htmlBreadCrumb, metaTitle, metaDescription, metaCanonical }) {
  //   this.content.innerHTML = html;
  //   this.contentTitle.innerText = this.activeTab.innerText;
  //   this.breadcrumb.innerHTML = htmlBreadCrumb;
  //   this.#updateActiveTab(tabType);
  //   document.title = metaTitle;
  //   document.querySelector('link[rel="canonical"]').href = metaCanonical;
  //   document.querySelector('meta[name=description]').content = metaDescription;
  // }

  // #updateActiveTab(type) {
  //   this.activeTab = this.tabs.find((tab) => tab.dataset.type === type);
  //   this.tabs.forEach((tab) => tab.classList.toggle(CLASSNAMES.ACTIVE, tab.dataset.type === type));
  // }
}

componentRegistry.define(CSS_PREFIX, FocusPage);

componentRegistry.define(
  'js-focusPage-listContainer',
  class {
    constructor({ el }) {
      this.el = el;
      this.overlay = new Overlay();
      this.el.addEventListener('click', (event) => {
        const target = event.target.closest('.js-focusPage-loadMore');
        if (target) {
          event.preventDefault();
          this.#load(target.dataset.href);
        }
      });
    }

    async #load(url) {
      this.overlay.show();
      try {
        this.el.outerHTML = await (
          await rejectNonOkResponse(
            fetch(url, {
              headers: {
                'X-Requested-With': 'XMLHttpRequest',
              },
            })
          )
        ).text();
      } finally {
        this.overlay.hide();
      }
    }
  }
);
